// @ts-ignore
import { bindActionCreators } from 'redux';
import createStore from './create-store';

// @ts-ignore
import { simpleActions, setActionTypes } from './actions-wrapper';

import { modules } from './loader';

const { actions } = modules;
const { reducers } = modules;

setActionTypes(actions);

export const store = createStore({}, reducers);
const wrappedActions = bindActionCreators(simpleActions(actions), store.dispatch);
const getState = () => store.getState();

export {
  // @ts-ignore
  wrappedActions as actions,
  reducers,
  getState,
};



// WEBPACK FOOTER //
// ./src/store/index.js